export const LOAD_REQUESTED = "WORKFLOW_SETTINGS_MODAL_ROW/LOAD_REQUESTED";
export const LOAD_SUCCESS = "WORKFLOW_SETTINGS_MODAL_ROW/LOAD_SUCCESS";
export const LOAD_FAIL = "WORKFLOW_SETTINGS_MODAL_ROW/LOAD_FAIL";

// eslint-disable-next-line no-unused-vars
export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadWorkflowSettingsModalRow = data => ({ type: LOAD_REQUESTED, data });
export const successLoadWorkflowSettingsModalRow = data => ({ type: LOAD_SUCCESS, data });
export const failLoadWorkflowSettingsModalRow = data => ({ type: LOAD_FAIL, data });
